import { useEffect, useState } from 'react';
import { Tusers, initialUsers } from '../../../type/users';
import {
	getChildren,
} from '../../../service/usersService';
import { FiHome } from 'react-icons/fi';
import { Link, useParams } from 'react-router-dom';
import LayoutChartHorizontal from '../../../components/organisms/OrgChart/LayoutChartHorizontal';
import { RootState } from '../../../redux/store';
import { useDispatch, useSelector } from 'react-redux';
import LayoutChartHorizontalTwo from '../../../components/organisms/OrgChart/LayoutChartHorizontalTwo';
import { setUser } from '../../../redux/utlsSlice';

const Chart = () => {
	const { users } = useSelector((state: RootState) => state.reducer.utlsSlice);

	const dispatch = useDispatch<any>();
	const { uniqueId } = useParams();

	const getMyDataProfile = async (uniqueId: string) => {
		const response = await getChildren(uniqueId);
		if (!response?.error) {
			const user: Tusers = response?.data;
			dispatch(setUser(response?.data))
		}
	};


	useEffect(() => {
		getMyDataProfile(uniqueId || '-');
	}, []);

	return (
		<div className="p-0 m-0">
			<Link
				className="fixed z-[9999] bottom-6 left-6 bg-gradient-to-r from-cyan-500 to-blue-500 text-white rounded-md border-gray-400 shadow-md py-3 px-5 flex items-center gap-2"
				to={'/admin'}
			>
				<FiHome /> Home
			</Link>
			<LayoutChartHorizontalTwo users={users} />
		</div>
	);
};

export default Chart;
